import React from 'react';
import { ScrollView, View, Text, Pressable } from 'react-native';
import { heightPercentageToDP as hp } from 'react-native-responsive-screen';

import CustomText from '../components/CustomText';
import styles from '../style/screens/privacyPolicyStyles';
import { useResponsiveStyles } from '../hooks';
import { DEFAULT_LANGUAGE, getActiveLanguage } from '../i18n';
import { useTranslation } from '../i18n';

const PrivacyPolicy = (props) => {
  const { t } = useTranslation('legal');

  // Use responsive styles hook for platform detection
  const { isDesktop, containerStyle } = useResponsiveStyles();

  return (
    <ScrollView style={containerStyle}>
      <Text style={styles.heading}>{t('legal:privacy.heading')}</Text>
      {/* Shown only to readers of a translation: the English text is the one
          that actually governs, and saying so is what makes translating a
          legal document safe. */}
      {getActiveLanguage() !== DEFAULT_LANGUAGE && (
        <Text style={styles.disclaimer}>{t('legal:privacy.disclaimer')}</Text>
      )}
      <View
        style={
          isDesktop
            ? { marginLeft: 150, marginRight: 150 }
            : { marginLeft: 15, marginRight: 15 }
        }
      >
        <Text>{t('legal:privacy.body1')}</Text>

        <Text style={styles.subheading}>{t('legal:privacy.h1')}</Text>
        <Text>{t('legal:privacy.body2')}</Text>

        <Text style={styles.subheading}>{t('legal:privacy.h2')}</Text>
        <Text>{t('legal:privacy.body3')}</Text>
        <View style={styles.bullets}>
          <Text>{t('legal:privacy.engagementBullet1')}</Text>
          <Text>{t('legal:privacy.engagementBullet2')}</Text>
          <Text>{t('legal:privacy.engagementBullet3')}</Text>
        </View>
        <Text>{t('legal:privacy.body4')}</Text>

        <Text style={styles.subheading}>{t('legal:privacy.h3')}</Text>
        <Text>{t('legal:privacy.noSell')}</Text>
        <Text>{t('legal:privacy.body5')}</Text>
        <Text>{t('legal:privacy.body6')}</Text>

        <Text style={styles.subheading}>{t('legal:privacy.h4')}</Text>
        <Text>{t('legal:privacy.body7')}</Text>
        <View style={styles.bullets}>
          <Text>{t('legal:privacy.securityMethod1')}</Text>
        </View>
        <Text>{t('legal:privacy.body8')}</Text>

        <Text style={styles.subheading}>{t('legal:privacy.h5')}</Text>
        <Text>{t('legal:privacy.body9')}</Text>
        <View style={styles.bullets}>
          <Text>{t('legal:privacy.deletionBullet1')}</Text>
          <Text>{t('legal:privacy.body10')}</Text>
        </View>
        <Text>{t('legal:privacy.body11')}</Text>
        <View style={styles.bullets}>
          <Text>{t('legal:privacy.body12')}</Text>
          <Text>{t('legal:privacy.body13')}</Text>
          <Text>{t('legal:privacy.body14')}</Text>
          <Text>{t('legal:privacy.body15')}</Text>
          <Text>{t('legal:privacy.exceptionCalecpa')}</Text>
          <Text>{t('legal:privacy.body16')}</Text>
          <Text>{t('legal:privacy.body17')}</Text>
          <Text>{t('legal:privacy.exceptionLegalObligation')}</Text>
          <Text>{t('legal:privacy.body18')}</Text>
        </View>

        <Text style={styles.subheading}>{t('legal:privacy.h6')}</Text>
        <Text>{t('legal:privacy.body19')}</Text>

        <Text style={styles.subheading}>{t('legal:privacy.h7')}</Text>
        <Text>{t('legal:privacy.body20')}</Text>

        <Text style={styles.subheading}>{t('legal:privacy.h8')}</Text>
        <Text>{t('legal:privacy.body21')}</Text>

        <Text style={styles.subheading}>{t('legal:privacy.h9')}</Text>
        <Text>{t('legal:privacy.body22')}</Text>

        <Text style={styles.subheading}>{t('legal:privacy.h10')}</Text>
        <Text>{t('legal:privacy.body23')}</Text>
        <View>
          <Text>Moneta LLC</Text>
          <Text>_________________</Text>
          <Text>Lubbock, Texas 79415</Text>
          <Text>{t('legal:privacy.emailAddressLabel')} timothy.matis@monetatech.net</Text>
          <Text>{t('legal:privacy.phoneNumberLabel')} 8063682281</Text>
        </View>

        <Text style={styles.date}>{t('legal:privacy.effectiveDate')}</Text>

        <View>
          <Pressable onPress={() => props.navigation.navigate('Login')}>
            <View style={{ cursor: 'pointer', marginBottom: 20 }}>
              <CustomText
                style={{ textDecorationLine: 'underline', marginTop: hp(3.9) }}
                size={24}
                color="#000"
              >
                {t('legal:privacy.returnToApp')}
              </CustomText>
            </View>
          </Pressable>
        </View>
      </View>
    </ScrollView>
  );
};

export default PrivacyPolicy;
